import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListMessanger = (params) => {
    return axios.get(`${backendHost}/api/admin/messanger`, {params});
};

export {
    getListMessanger
}